module.exports = __webpack_public_path__ + "img/lock.c3d5669f.png";